import { PRIVACY_URL, SUPPORT_EMAIL, TERMS_URL } from "../lib/copy";
import { openCookieSettings } from "./ConsentBanner";

/**
 * The foot of every page (Edward, Nov 4: there was no way for anyone to get help): how to reach us,
 * who's behind it, and the policies (no theme switch: it follows the device). The address is shown
 * in full so someone with no mail app on their phone can still copy it.
 */
export function AppFooter() {
  return (
    <footer className="mt-auto flex flex-col gap-1 pt-10 text-center text-[13px] text-muted print:hidden">
      <p>
        Need help? Email{" "}
        <a href={`mailto:${SUPPORT_EMAIL}?subject=Gifts%20Profile%20help`} className="break-words text-muted">
          {SUPPORT_EMAIL}
        </a>
      </p>
      <p>
        <a href={PRIVACY_URL} target="_blank" rel="noopener noreferrer" className="text-muted">
          Privacy
        </a>{" "}
        ·{" "}
        <a href={TERMS_URL} target="_blank" rel="noopener noreferrer" className="text-muted">
          Terms
        </a>{" "}
        ·{" "}
        <button type="button" className="text-muted underline" onClick={openCookieSettings}>
          Your privacy choices
        </button>
      </p>
      <p>© {new Date().getFullYear()} Novos Network</p>
    </footer>
  );
}
